import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

// Compact single-row filter strip — labels become placeholders.
export default function FiltersBar({
  dateFrom, setDateFrom, dateTo, setDateTo,
  phoneFilter, setPhoneFilter,
  bookingRefFilter, setBookingRefFilter,
  emailFilter, setEmailFilter,
  onApply, onClear,
}) {
  const anyActive = dateFrom || dateTo || phoneFilter || bookingRefFilter || emailFilter;

  return (
    <Card className="px-3 py-2 mb-4">
      <div className="flex flex-wrap items-center gap-2">
        <Input
          type="text"
          value={phoneFilter}
          onChange={(e) => setPhoneFilter(e.target.value)}
          placeholder="Phone…"
          className="w-40 h-9"
          data-testid="phone-filter"
        />
        <Input
          type="text"
          value={bookingRefFilter}
          onChange={(e) => setBookingRefFilter(e.target.value)}
          placeholder="Booking Ref"
          className="w-36 h-9"
          data-testid="booking-ref-filter"
        />
        <Input
          type="text"
          value={emailFilter}
          onChange={(e) => setEmailFilter(e.target.value)}
          placeholder="Email…"
          className="w-48 h-9"
          data-testid="email-filter"
        />
        <Input
          type="date"
          value={dateFrom}
          onChange={(e) => setDateFrom(e.target.value)}
          title="From date"
          className="w-44 h-9"
          data-testid="date-from-filter"
        />
        <Input
          type="date"
          value={dateTo}
          onChange={(e) => setDateTo(e.target.value)}
          title="To date"
          className="w-44 h-9"
          data-testid="date-to-filter"
        />
        <Button
          size="sm"
          onClick={onApply}
          className="bg-emerald-700 hover:bg-emerald-800 text-white"
          data-testid="apply-filters-btn"
        >
          Apply
        </Button>
        {anyActive && (
          <Button
            size="sm"
            variant="ghost"
            onClick={onClear}
            data-testid="clear-filters-btn"
          >
            Clear
          </Button>
        )}
      </div>
    </Card>
  );
}
